/**
 * A one-shot ask for the lesson page about to open (decision 165): an Action card's "Suggest a Different Time"
 * on Lessons or in the thread opens the lesson, in the pane or as a page, with its Request a New Time already up.
 * The page that shows it reads it (hasMove) and clears it once shown (clearMove); one that only hands over to
 * Lessons' pane on a desktop leaves it for the pane.
 */
const moves = new Set<string>();

export function requestMove(bookingId: string): void {
  moves.add(bookingId);
}

export function hasMove(bookingId: string | undefined): boolean {
  return !!bookingId && moves.has(bookingId);
}

export function clearMove(bookingId: string | undefined): void {
  if (bookingId) moves.delete(bookingId);
}
